// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DeleteCampaignFieldMappingRequestModel from '../../model/delete-campaign-field-mapping-request-model';
import DeleteCampaignFieldMappingRequestDTO from '../dto/delete-campaign-field-mapping-request-dto';
import dtoSchema from '../schemas/delete-campaign-field-mapping-request-schema';

export default abstract class DeleteCampaignFieldMappingRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DeleteCampaignFieldMappingRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int32}
  */
  id?: number;

  static toModel(dto: DeepPartial<DeleteCampaignFieldMappingRequestDTO>): DeleteCampaignFieldMappingRequestModel;
  static toModel(dto: DeepPartial<DeleteCampaignFieldMappingRequestDTO> | undefined | null): DeleteCampaignFieldMappingRequestModel | undefined;
  static toModel(dto: DeepPartial<DeleteCampaignFieldMappingRequestDTO> | undefined | null): DeleteCampaignFieldMappingRequestModel | undefined {
    return dto ? new DeleteCampaignFieldMappingRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DeleteCampaignFieldMappingRequestModel> | DeleteCampaignFieldMappingRequestModel): DeleteCampaignFieldMappingRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as DeleteCampaignFieldMappingRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DeleteCampaignFieldMappingRequestModel, can not map to DeleteCampaignFieldMappingRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
